import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Grid2, useTheme } from '@mui/material';
import TableComponent from 'components/grid';
import { useGetSubmittedScheduleDPRListQuery } from 'store/slices/apis/scheduleDprSlice';
import moment from 'moment';
import PaginationComponent from 'components/ui-components/PaginationComponent';

const columns = [
    {
        name: 'Reporting Date',
        field: 'reportedDate',
        renderer(params) {
            return (
                <>
                    {params?.reportedDate
                        ? moment(params?.reportedDate).format("DD-MM-YYYY")
                        : "N.A."}
                </>
            );
        },
    },
    // {
    //     name: 'Reported By',
    //     field: 'name',
    // },
    {
        name: 'Activity Count',
        field: 'activityCount',
    },
    {
        name: 'Submitted On',
        field: 'createddate',
        renderer(params) {
            return (
                <>
                    {params?.createddate
                        ? moment(params?.createddate).format("DD-MM-YYYY")
                        : "N.A."}
                </>
            );
        },
    },
    {
        name: 'Action',
        field: 'action',
        option: {
            view: true
        },
    }
];

const SubmittedByMeScheduleDPR = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [pageNumber, setPageNumber] = useState(1);
    const { projectId } = useParams();

    const listResponse = useGetSubmittedScheduleDPRListQuery({ projectId, page: pageNumber, pageSize: 10 });

    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    const handleActionView = (row) => {
        const encrypted = encrypt("view");
        navigate(`/projects/${projectId}/quantitydpr-detail/${row?.id}/${encrypted}/false`);
    };

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12} sx={{ mt: 0 }}>
                    <TableComponent
                        columns={columns}
                        data={listResponse?.data?.data?.dprs}
                        isLoading={listResponse?.isLoading}
                        actionView={handleActionView}
                    />
                    {!listResponse?.isLoading && (
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <PaginationComponent
                                pageNumber={listResponse?.data?.data?.page || 1}
                                totalPages={Math.ceil(listResponse?.data?.data?.totalRecords / listResponse?.data?.data?.pageSize) || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2>
        </>
    );
};

export default SubmittedByMeScheduleDPR;